import { HttpTransportType, HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { ThemeProvider } from '@mui/material/styles';
import axios from 'axios';
import React, { useEffect } from 'react';
import { useSelector } from "react-redux";
import { Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import IntlProviderConfigured from './_i18n/intlproviderconfigured';
import { useChatHubContext } from './contexts/chatHubContext';
import { browserHistory } from './helpers/history';
import './paginate.css';
//import './styles/mexx-variables.css';
// import './styles/mexx-variables-redesign.css';
import './styles/mexx-animations.css';
import './styles/mexx-global-override.css';
import { persistor } from './redux/store';
import Routes from './routes';
import { baseURL } from "./services/api";
import theme from './styles/theme';
import { PapiroConsole } from './utils/papiroConsole';

import { useMessageHub2TalkContext } from './contexts/MessageHub2TalkContext';
import { useAgentWorkspaceHubContext } from './contexts/AgentWorkspaceHubContext';
import { baseURLApiSignalrHub, baseURLCone } from "./services/api";
import Api from './services/api';
import ThemeLoader from './components/theme/ThemeLoader';

// Onboarding (Trial) — F5
// Renderizado em nivel global (fora do <Routes>) pra garantir que aparece em
// QUALQUER pagina, mesmo as que nao usam o layout-base/Base (ex.: called-list).
// Cada componente tem seu proprio gate isUserOnTrial(user) — usuarios pagos
// nao veem nada e nao consomem recursos.
import OnboardingHubProvider from './contexts/OnboardingHubContext';
import WelcomeModal from './components/onboarding/welcome-modal';
import ChecklistFab from './components/onboarding/checklist-fab';
import ProductTour from './components/onboarding/product-tour';

function App() {
    const { 
      setChatHubConnection,
      setOpenChatListInitialValue,
      setClosedChatListInitialValue,
      setAllNotifications,
      
      setNewNotification,
      setNewPrivateMessage,
      setNotificationSound,
      setOpenClientChat,
      loadChatMessages,
      handleNewChat,
      UpdateChatInTheList,
      closeChat,
      ShowError,
      Ok,
      sendAccompanimentNotification,
    } = useChatHubContext();

    const {
      setChatHubConnection2Talk,
      setNotificationSound2Talk,
      CloseChat2Talk,
      TemplateMessageActiveUpdateList,
      ShowError2Talk,
      InitChat2Talk,
      ReceiveNotification,
      ReceiveMessage,
      ReceiveNewChat,
      MessageSent,
      NewItemNotification,
      setAllNotificationsBy2TalkHub

    } = useMessageHub2TalkContext();

    const {
      setAgentWorkspaceHubConnection,
      handleQueueUpdated,
      handleNewItem,
      handleItemRemoved,
      handleItemUpdated,
      handleItemClosed,
      handleMetricsUpdated,
      handleSlaCritical,
      handleNewMessage,
      handleShowError: handleAgentWorkspaceError,
    } = useAgentWorkspaceHubContext();

    const userSession = useSelector((state) => state.userSession);

    const isClient = (userSession) => {
      let isClient = true;
      userSession.user.userrole.map(item => {
        if (item.role.roletype != 3) {
            isClient = false
        }
      })
      return isClient
    };

    // =============================================
    // Reconnection helpers (shared)
    // =============================================
    const removeTrailingSlash = (url) => {
      if (url.endsWith('/')) return url.slice(0, -1);
      return url;
    };

    const RETRY_DELAYS = [0, 2000, 5000, 10000, 15000, 30000];

    const infiniteRetryPolicy = {
      nextRetryDelayInMilliseconds(retryContext) {
        const index = Math.min(retryContext.previousRetryCount, RETRY_DELAYS.length - 1);
        return RETRY_DELAYS[index];
      }
    };

    /** Inicia (ou reinicia) uma conexão SignalR com retry infinito e guard de concorrência. */
    async function startHubWithRetry(connection, onConnected, label) {
      if (connection.__isReconnecting) return;
      connection.__isReconnecting = true;

      let attempt = 0;
      while (true) {
        try {
          await connection.start();
          console.log(`[${label}] SignalR Connected.`);
          onConnected(connection);
          connection.__isReconnecting = false;
          return;
        } catch (err) {
          const delay = RETRY_DELAYS[Math.min(attempt, RETRY_DELAYS.length - 1)];
          attempt++;
          console.error(`[${label}] Falha ao conectar (tentativa ${attempt}), retry em ${delay}ms...`, err);
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      }
    }

    // =============================================
    // Hub 2Talk
    // =============================================
    const handleHubConnection2Talk = async (accessToken, userId) => {
      try {
        let chatHub2Talk = null; 

        if(baseURLApiSignalrHub != null){

            let baseUrlHub = removeTrailingSlash(baseURLApiSignalrHub);
           chatHub2Talk = new HubConnectionBuilder()
           .withUrl(`${baseUrlHub}/hub/notification`, { accessTokenFactory: () => accessToken,
             withCredentials: true,
             skipNegotiation: true,logMessageContent: true ,
            // eslint-disable-next-line no-undef
                transport: HttpTransportType.WebSockets,
                }).configureLogging(LogLevel.Information)
                .withAutomaticReconnect(infiniteRetryPolicy)
                .build();
    
        }
        else{

          var urlbase = "https://messengerhub.homologa.api.mexx.ai";

          if (Api != null && (Api.getSassHirerId() == 1011 || Api.getSassHirerId() == 15) ) {// speed
            if ((document.location.host.indexOf("homologa") > -1)) { // sppeed homologa
              urlbase ="https://speedmais.api.homologa.messengerhub.mexx.ai";
            }
            else{  // speed prod
              urlbase="https://portaldeservicos.economia.messengerhub.api.mexx.ai"; 
            }
          }
          else{
            if ((document.location.host.indexOf("homologa") > -1)) { // SaaS homologa
               urlbase = "https://messengerhub.homologa.api.mexx.ai"; 
            }
            else{ // SaaS prod
              urlbase="https://messengerhub.api.mexx.ai";
            }
          }

            let baseUrlHub = removeTrailingSlash(urlbase);
            chatHub2Talk = new HubConnectionBuilder()
            .withUrl(`${baseUrlHub}/hub/notification`, { accessTokenFactory: () => accessToken,
              withCredentials: true,
              skipNegotiation: true,logMessageContent: true ,
             // eslint-disable-next-line no-undef
                 transport: HttpTransportType.WebSockets,
                 }).configureLogging(LogLevel.Information)
                 .withAutomaticReconnect(infiniteRetryPolicy)
                 .build();
        }


        chatHub2Talk.onreconnecting((error) => {
          console.warn('[2Talk] SignalR reconectando...', error);
        });

        chatHub2Talk.onreconnected((connectionId) => {
          console.log('[2Talk] SignalR reconectado. ConnectionId:', connectionId);
        });

        chatHub2Talk.onclose(async (error) => {
          console.error('[2Talk] SignalR desconectado definitivamente. Reiniciando...', error);
          await startHubWithRetry(chatHub2Talk, setChatHubConnection2Talk, '2Talk');
        });


        chatHub2Talk.on("Log", (message, log) => {
          PapiroConsole.log("=== conversations.js - chatHub2Talk => message, log ===")
          PapiroConsole.log(message)
          PapiroConsole.log(log)
          alert(message);
        });
        chatHub2Talk.on("OnConnected", (connectionid, userid, message) => {
          PapiroConsole.log("=== conversations.js - hub connected ===")
          userSession.connectionid= connectionid;

          localStorage.removeItem('connectionid2talk')
        });

        chatHub2Talk.on("ShowError", ShowError2Talk);
    
        chatHub2Talk.on("InitChat", InitChat2Talk)
  
        chatHub2Talk.on("PlayNotificationSound", setNotificationSound2Talk);
  
        chatHub2Talk.on("CloseChat", CloseChat2Talk);
        chatHub2Talk.on("TemplateMessageActiveUpdateList", TemplateMessageActiveUpdateList);
        chatHub2Talk.on("ReceiveNotification", ReceiveNotification);
        chatHub2Talk.on("ReceiveMessage", ReceiveMessage);
        
        chatHub2Talk.on("ReceiveNewChat", ReceiveNewChat);
        chatHub2Talk.on("MessageSent", MessageSent);
        chatHub2Talk.on("NewItemNotification", NewItemNotification);
        
        chatHub2Talk.on("ListNotifications", setAllNotificationsBy2TalkHub);
        
        chatHub2Talk.on("RegisterConnectionId", (ok, connections) => {
        });
  
        await startHubWithRetry(chatHub2Talk, setChatHubConnection2Talk, '2Talk');
        
      
        if(userSession && userSession.user){
          //await chatHub2Talk.invoke("ListClientOpenChats", userId);  
        }
        
      } catch(err) {
          PapiroConsole.log("=== handleHubConnection2Talk -> error === ")
          console.error(err);
      }
    }

    // =============================================
    // Hub principal (chat)
    // =============================================
    const handleHubConnection = async (accessToken, userId) => {
        try {
          PapiroConsole.log(baseURL)
          PapiroConsole.log("baseURL")
          PapiroConsole.log("accessToken")
          PapiroConsole.log(accessToken)
          PapiroConsole.log(userId)
          const chatHub = new HubConnectionBuilder()
          .withUrl(`${baseURL}/chat`,  { accessTokenFactory: () => accessToken, skipNegotiation: true,
            UseDefaultCredentials: true,
          // eslint-disable-next-line no-undef
          transport: HttpTransportType.WebSockets })
          .withAutomaticReconnect(infiniteRetryPolicy)
          .build();

          chatHub.onreconnecting((error) => {
            PapiroConsole.log("[ChatHub] reconectando")
          });

          chatHub.onreconnected((connectionId) => {
            PapiroConsole.log("[ChatHub] reconexão feita")
          });

          chatHub.onclose(async (error) => {
            console.error('[ChatHub] SignalR desconectado definitivamente. Reiniciando...', error);
            await startHubWithRetry(chatHub, setChatHubConnection, 'ChatHub');
          });

          await startHubWithRetry(chatHub, setChatHubConnection, 'ChatHub');
  
          chatHub.on("Log", (message, log) => {
            PapiroConsole.log("=== APP.js - chatHub => message, log ===")
            PapiroConsole.log(message)
            PapiroConsole.log(log)
          });

          PapiroConsole.log("entrei aqui no chathub")
          chatHub.on("ShowError", ShowError);

          chatHub.on("Ok", Ok);

          chatHub.on("InitChat", handleNewChat)

          chatHub.on("InitChatByTech", handleNewChat)
  
          chatHub.on("SendPrivateMessage", setNewPrivateMessage);

          chatHub.on("PlayNotificationSound", setNotificationSound);

          chatHub.on("ListOpenChats", setOpenChatListInitialValue)
          
          chatHub.on("ListClosedChats", setClosedChatListInitialValue)

          chatHub.on("ListNotifications", setAllNotifications)

          chatHub.on("NewNotification", setNewNotification)

          chatHub.on("ListClientOpenChats", setOpenChatListInitialValue)

          chatHub.on("ClientOpenChat", setOpenClientChat)
          
          chatHub.on("LoadChatMessages", loadChatMessages);

          chatHub.on("SendAccompanimentNotification", sendAccompanimentNotification);

          chatHub.on("ResetNotSeenMessages", UpdateChatInTheList);
          
          chatHub.on("CloseChat", closeChat);
          
          chatHub.on("RegisterConnectionId", (ok, connections) => {
          });

          PapiroConsole.log("estou aqui")
          PapiroConsole.log(userSession)

          if(userSession && userSession.user){
            PapiroConsole.log("entrei aqui")
            isClient(userSession) ? await chatHub.invoke("ListClientOpenChats", userId) : await chatHub.invoke("ListOpenChats", userId);  
            await chatHub.invoke("ListClosedChats", userId)
            await chatHub.invoke("ListNotifications", userId)
          }
          
        } catch(err) {
          PapiroConsole.log("=== handleHubConnection -> error === ")
          PapiroConsole.log(err);
        }
    }

    // =============================================
    // Hub Agent Workspace
    // =============================================
    const handleAgentWorkspaceHubConnection = async (accessToken, userId) => {
      try {
        PapiroConsole.log("=== handleAgentWorkspaceHubConnection ===");
        const agentWorkspaceHub = new HubConnectionBuilder()
          .withUrl(`${baseURL}/agent-workspace-hub`, {
            accessTokenFactory: () => accessToken,
            skipNegotiation: true,
            UseDefaultCredentials: true,
            transport: HttpTransportType.WebSockets
          })
          .withAutomaticReconnect(infiniteRetryPolicy)
          .build();

        agentWorkspaceHub.onreconnecting((error) => {
          PapiroConsole.log("[AgentWorkspaceHub] reconectando", error);
        });

        agentWorkspaceHub.onreconnected((connectionId) => {
          PapiroConsole.log("[AgentWorkspaceHub] reconexão feita", connectionId);
        });

        agentWorkspaceHub.onclose(async (error) => {
          console.error('[AgentWorkspaceHub] SignalR desconectado definitivamente. Reiniciando...', error);
          await startHubWithRetry(agentWorkspaceHub, setAgentWorkspaceHubConnection, 'AgentWorkspaceHub');
        });


        // Bind event handlers
        agentWorkspaceHub.on("QueueUpdated", handleQueueUpdated);
        agentWorkspaceHub.on("NewItem", handleNewItem);
        agentWorkspaceHub.on("ItemRemoved", handleItemRemoved);
        agentWorkspaceHub.on("ItemUpdated", handleItemUpdated);
        agentWorkspaceHub.on("ItemClosed", handleItemClosed);
        agentWorkspaceHub.on("MetricsUpdated", handleMetricsUpdated);
        agentWorkspaceHub.on("SlaCritical", handleSlaCritical);
        agentWorkspaceHub.on("NewMessage", handleNewMessage);
        agentWorkspaceHub.on("ShowError", handleAgentWorkspaceError);

        agentWorkspaceHub.on("OnConnected", (connectionId, userId) => {
          PapiroConsole.log("AgentWorkspaceHub: OnConnected", connectionId, userId);
        });

        agentWorkspaceHub.on("JoinedGroup", (groupName) => {
          PapiroConsole.log("AgentWorkspaceHub: JoinedGroup", groupName);
        });
        await startHubWithRetry(agentWorkspaceHub, setAgentWorkspaceHubConnection, 'AgentWorkspaceHub');
        PapiroConsole.log("AgentWorkspaceHub: Connected");



      } catch (err) {
        PapiroConsole.log("=== handleAgentWorkspaceHubConnection -> error ===");
        PapiroConsole.log(err);
      }
    };

    useEffect(() => {
      try {
      
        if (userSession && userSession.user) {
          
          const { id, accesstoken,accesstoken2talk } = userSession.user;

          var available = false 
          if(userSession.user && userSession.user.productsavailables){
            var productsavailables = userSession.user.productsavailables;
            productsavailables.forEach(element => {
              if (element.id == 2) {
                available = true
              }
            });
          }

          if(accesstoken2talk){
            handleHubConnection2Talk(accesstoken2talk, id);
          }

          axios.get(`${baseURL}/users/verifyToken`, {
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer "+accesstoken },
          }).then(result => {
              if(result.data.success){
          PapiroConsole.log("entrei no hub connection")
                //handleHubConnection(accesstoken, id);
                handleAgentWorkspaceHubConnection(accesstoken, id);
              }
          })
          .catch(err => {

          console.log("verifyToken")
          console.log(err)
          });

          
        }
      } catch(err) {
        throw err;
      }
    }, []);

    return (
        <>
        <ThemeLoader />
        <PersistGate loading={null} persistor={persistor}>
            <ThemeProvider theme={theme}>
                <Router history={browserHistory}>
                    <IntlProviderConfigured>
                        <OnboardingHubProvider>
                            <Routes>

                            </Routes>

                            {/* Onboarding (Trial) — overlays globais. Cada um se auto-controla
                                via isUserOnTrial(user) + estado Redux. */}
                            <WelcomeModal />
                            <ChecklistFab />
                            <ProductTour />
                        </OnboardingHubProvider>
                    </IntlProviderConfigured>
                </Router>
            </ThemeProvider>
        </PersistGate>
        </>

    );
}

export default App;